<template>
  <main>
    <div class="py-12 md:px-12 lg:px-14 p-4 max-w-screen-2xl mx-auto">
      <h1 class="text-center text-lg font-black mt-10">Featured Videos</h1>

      <!-- Featured youtube video -->
      <div class="flex flex-col lg:flex-row items-center gap-5 mt-10">
        <div class="lg:w-3/5 w-full">
          <iframe
            src="https://www.youtube.com/embed/aGSSXL-_QSY"
            title="YouTube video player"
            frameborder="0"
            class="lg:w-full lg:h-96 md:w-full md:h-full rounded-2xl"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="lg:w-2/5 w-full">
          <h3 class="text-xl text-main font-extrabold">Success In Realestate...</h3>
          <p class="text-2xl mt-4">
            Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
            molestie senectus consectetur sagittis sit tortor imperdiet arcu.
            Nunc quam dolor ac arcu. Urna feugiat tristique vel enim ultrices.
            Consectetur maecenas erat nisl tellus. Consectetur pellentesque
            ullamcorper hendrerit dolor nisi sit. Pretium nibh at nunc sed at.
            Senectus faucibus venenatis quisque arcu interdum sed proin. Tellus
            dapibus quis turpis phasellus nisi praesent magna. Habitant fames
            lobortis eu fusce hendrerit egestas eu proin suspendisse.
          </p>
          <p class="text-2xl mt-4">
            Tellus dapibus quis turpis phasellus nisi praesent magna. Habitant
            fames lobortis eu fusce hendrerit egestas eu proin suspendisse.
          </p>
        </div>
      </div>

      <!-- Featured video 2 -->
      <div class="flex flex-col lg:flex-row items-center gap-5 mt-10">
        <div class="lg:w-3/5 w-full">
          <iframe
            src="https://www.youtube.com/embed/6q3h90CEpa4"
            title="YouTube video player"
            frameborder="0"
            class="lg:w-full lg:h-96 md:w-full md:h-full rounded-2xl"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div class="lg:w-2/5 w-full">
          <h3 class="text-xl text-main font-extrabold">Desperate times call for desperate measures...</h3>
          <p class="text-2xl mt-4">
            Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
            molestie senectus consectetur sagittis sit tortor imperdiet arcu.
            Nunc quam dolor ac arcu. Urna feugiat tristique vel enim ultrices.
            Consectetur maecenas erat nisl tellus. Consectetur pellentesque
            ullamcorper hendrerit dolor nisi sit. Pretium nibh at nunc sed at.
            Senectus faucibus venenatis quisque arcu interdum sed proin. Tellus
            dapibus quis turpis phasellus nisi praesent magna. Habitant fames
            lobortis eu fusce hendrerit egestas eu proin suspendisse.
          </p>
          <p class="text-2xl mt-4">
            Tellus dapibus quis turpis phasellus nisi praesent magna. Habitant
            fames lobortis eu fusce hendrerit egestas eu proin suspendisse.
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
